import { ArtistRiderActivityPanel } from "ArtistRider/activity/ArtistRiderActivityPanel";
import { ArtistRiderDetailSection } from "ArtistRider/ArtistRiderDetailSection";
import ArtistRiderOptionsPanel from "ArtistRider/ArtistRiderOptionsPanel";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import SupportArticlePanel from "components/SupportArticlePanel/SupportArticlePanel";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";

const ArtistRiderDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ArtistRiderDetailFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          <ArtistRiderDetailSection
            artistRider={viewModel.artistRider}
          />
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <ArtistRiderOptionsPanel
            optionsPanelData={viewModel.optionsPanel}
            listUrl={viewModel.listUrl}
            artistRiderId={viewModel.artistRider.artistRiderId}
          />
          <SupportArticlePanel
            config={viewModel.articlePanelConfig}
          />
          <ArtistRiderActivityPanel
            fileId={viewModel.artistRider.fileId}
            config={viewModel.activityPanelConfig}
            artistRiderId={viewModel.artistRider.artistRiderId}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>
}

export default ArtistRiderDetailApp;